var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"td-content",domProps:{"innerHTML":_vm._s(_vm.header.formatter(_vm.data, _vm.data[_vm.header.field], _vm.header.field))}})
}
var staticRenderFns = []

export { render, staticRenderFns }